import { render, staticRenderFns } from "./List.vue?vue&type=template&id=7e4c8c5d"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4c8c5d')) {
      api.createRecord('7e4c8c5d', component.options)
    } else {
      api.reload('7e4c8c5d', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=7e4c8c5d", function () {
      api.rerender('7e4c8c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/researchPeriod/List.vue"
export default component.exports